import { normalize } from "normalizr";
import { asyncAction } from "./actions";
import schemas from "../schemas";
import api from "../services/api";

export const fetchReferenceData = (accessToken) =>
  asyncAction("FETCH_REF_DATA", api.referenceData.list(accessToken), {
    responseTransformer: (refData) => normalize(refData, schemas.referenceData),
  });
